import api from '@/utils/api';

/**
 * Get  dealer's quotes by a selected dealer quote
 * @param {string} dealerQuoteId - the dealer quote id
 * @returns {Promise}
 */
const getDealerQuoteApi = (dealerQuoteId) => {
  const url = `quote/${dealerQuoteId}`;
  return api.get(url);
};

export default getDealerQuoteApi;
